import { RouteRecordRaw } from 'vue-router';

const JOB_FUNCTION_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'JobFunctionsOverview',
      component: () => import('@/modules/job-functions/pages/JobFunctionsOverview.vue'),
   },
];

export default JOB_FUNCTION_ROUTES;
